import gameNames from '../../hub/data/GameIds';

const initialState = { currentActivityWindow: '' };

const activityReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'SET_ACTIVITY_WINDOW':
      return { ...state, currentActivityWindow: action.payload.window };
    default:
      return state;
  }
};

export default activityReducer;
